import { Link } from 'react-router-dom';
import DocumentHead from '../components/DocumentHead';

export default function Termini() {
  return (
    <div className="min-h-screen bg-[var(--mang-bg,#FFFEFA)]">
      <DocumentHead
        title="Termini e condizioni"
        description="Termini di utilizzo della piattaforma Mangitalia per clienti e produttori alimentari."
        path="/termini"
      />
      <div className="max-w-3xl mx-auto px-4 py-12 prose prose-neutral">
        <p className="text-sm mb-6">
          <Link to="/" className="text-[#c78244] underline">← Home</Link>
        </p>
        <h1 className="text-3xl font-bold text-[#c78244] mb-6">Termini e condizioni</h1>
        <p className="text-gray-600 text-sm mb-8">Ultimo aggiornamento: luglio 2026</p>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">1. Oggetto</h2>
          <p>
            Mangitalia è una piattaforma che collega produttori alimentari italiani selezionati
            a consumatori che desiderano acquistare eccellenze con provenienza e qualità curate.
            Questi termini regolano l&apos;uso del sito, del catalogo, degli account e dei servizi correlati.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">2. Account</h2>
          <p>
            Cliente e produttore sono responsabili della veridicità dei dati forniti e della
            custodia delle credenziali. L&apos;accesso ai pannelli riservati è personale.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">3. Prodotti e ordini</h2>
          <p>
            Il catalogo può includere prodotti freschi e secchi di diverse categorie alimentari
            (latticini, salumi, olio, pasta, conserve, frutta secca e altre eccellenze).
            Prezzi, disponibilità e tempi di consegna dipendono da categoria, produttore assegnato
            e indirizzo. In fase di anteprima gli ordini possono essere disabilitati.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">4. Produttori</h2>
          <p>
            L&apos;ingresso in catalogo avviene tramite candidatura e valutazione. Il produttore
            garantisce conformità normativa (etichettatura, allergeni, igiene, tracciabilità)
            e la qualità dichiarata. Mangitalia può sospendere o rimuovere prodotti non conformi.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">5. Pagamenti e rimborsi</h2>
          <p>
            I pagamenti sono gestiti tramite i provider indicati in piattaforma (es. Stripe).
            Eventuali rimborsi seguono le policy pubblicate e lo stato dell&apos;ordine.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">5-bis. Documenti fiscali</h2>
          <p>
            I PDF generati dalla piattaforma (ricevute di pagamento, riepiloghi ordine, accrediti portafoglio)
            sono <strong>documenti operativi</strong> e non costituiscono di per sé fattura elettronica
            ai sensi della normativa italiana. La fatturazione elettronica (SDI) segue il modello
            fiscale applicabile (intermediazione o altro) e sarà emessa dai soggetti obbligati
            con i dati anagrafici raccolti in piattaforma. Maggiori dettagli per i produttori:
            pagina <Link to="/per-partner" className="text-[#c78244] underline">Modello di business</Link>.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">6. Limitazioni</h2>
          <p>
            Nei limiti di legge, Mangitalia non risponde di ritardi logistici indipendenti dalla
            piattaforma o di usi impropri del servizio da parte di terzi.
          </p>
        </section>

        <section className="space-y-4 text-gray-700 leading-relaxed mb-8">
          <h2 className="text-xl font-semibold text-gray-900">7. Contatti</h2>
          <p>
            Per richieste su questi termini usa i canali indicati sul sito o la pagina{' '}
            <Link to="/segnalazione" className="text-[#c78244] underline">Segnalazione</Link>.
          </p>
        </section>

        <p className="text-sm text-gray-500 pt-4 border-t">
          Vedi anche{' '}
          <Link to="/privacy" className="text-[#c78244] underline">Privacy Policy</Link>
          {' '}e{' '}
          <a href="https://www.iubenda.com/privacy-policy/91887353/cookie-policy" className="text-[#c78244] underline" target="_blank" rel="noreferrer">
            Cookie Policy
          </a>.
        </p>
      </div>
    </div>
  );
}
